module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0036.jpg?v=4818d10f";